import React, {Component} from 'react';
import {Field} from 'redux-form';
import {injectIntl, intlShape} from 'react-intl';
import TextField from '../../../shared-components/TextField/TextField';
import {isEmpty} from '../../../shared-components/FormElement/FormElementUtils';
import PropTypes from 'prop-types';

const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressForm';

export class Name extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        validations: PropTypes.arrayOf(PropTypes.func)
    };

    render() {
        const { intl, id, name, label} = this.props;
        let { validations = [] } = this.props;
        validations = [
            isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.billinginfo-empty`})),
            ...validations
        ];
        return (
            <Field
                id={id}
                name={name}
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="off"
                component={TextField}
                label={label}
                validate={validations}
            />
        );
    }
}

export default injectIntl(Name);

